import React, { FC } from 'react';

interface IModal {
  children?: React.ReactNode;
  renderFooter?: () => React.ReactNode;
  title: string;
  isModalOpen: boolean;
  closeModal: () => void;
  modalSize?: 'modal-xl' | 'modal-md' | 'modal-sm';
  height?: string;
  overflowY?: 'auto' | 'visible';
  staticBackdrop?: boolean;       // new
  noKeyboardClose?: boolean;      // new
}

const Modal: FC<IModal> = ({
  children,
  renderFooter,
  title,
  isModalOpen,
  closeModal,
  height,
  overflowY = 'auto',
  modalSize = 'modal-xl',
  staticBackdrop = false,
  noKeyboardClose = false,
}) => {
  if (!isModalOpen) return null;

  return (
    <div
      className="modal fade show d-block"
      tabIndex={-1}
      aria-labelledby="modal-title"
      aria-modal="true"
      role="dialog"
      style={{ backgroundColor: 'rgba(0,0,0,0.5)' }} // slightly darker overlay
      onClick={(e) => {
        if (e.target === e.currentTarget && !staticBackdrop) {
          closeModal();
        }
      }}
    >
      <div className={`modal-dialog modal-dialog-centered ${modalSize}`}>
        <div
          className="modal-content shadow-xl border-0 rounded-4"
          style={{
            height: height || 'auto',
            borderRadius: '1.1rem', // modern rounded corners
          }}
        >
          <div className="modal-header border-0 pb-0 pt-4 px-4">
            <h5 className="modal-title fw-semibold fs-5" id="modal-title">
              {title}
            </h5>
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={closeModal}
            />
          </div>

          <div className="modal-body px-4 pb-4">{children}</div>

          {renderFooter && (
            <div className="modal-footer border-0 pt-2 px-4 pb-4">
              {renderFooter()}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Modal;